module.exports = __webpack_public_path__ + "static/media/Item.342b5531.svg";